import axios from 'axios'
import crel from 'crel'
import './settings'
import {resolver} from './util'
import settings from "./settings";

let korak = null;
if(location.href.includes('/store/order/create'))
    korak = '3 korak: Naročilo'
if(location.href.includes('/store/order/checkout'))
    korak = '4 korak: Potrditev plačila'
if(location.href.includes('/store/order/end'))
    korak = '5 korak: Zaključek'

/*
window.addEventListener('load', function () {

    if (checkCookie("analiticni") != true) return
    const script = settings.site_type != 'production' ? 22825699 : 25280231
    const srv = settings.site_type != 'production' ? 'js': 'js-eu1'
    crel(document.head, crel('script', {id: 'hs-script-loader', src: `//${srv}.hs-scripts.com/${script}.js`}))

    if(!korak) return

    const send_data = async () => {
        const {result, error} = await resolver(axios.get(`${location.origin}/services/apiv2/user_data/`))
        if (error) return alert(error)

        const email = !result.data.authenticated ? 'Anonymous' : result.data.user_email

        _hsq.push(["identify", {email}]);
        _hsq.push([
            'trackCustomBehavioralEvent',
            {
                name: `pe${script}_via_v2`,
                properties: {
                    url: location.href,
                    step: korak
                },
            },
        ]);
    }

    console.log('Loaded: Hubspot')


    // Because the _hsq does not appear at any known time, we need to do this
    (function myLoop() {
        setTimeout(function () {
            if (!window._hsq) return myLoop();
            if(korak) send_data()
        }, 100)
    })();
})
*/

export const hubspot = () => {
    console.log('Loaded: hubspot.js')

    const consent = window.Didomi.getUserConsentStatusForVendor('c:hubspot')
    if (!consent) return

    const script = settings.site_type != 'production' ? 22825699 : 25280231
    const srv = settings.site_type != 'production' ? 'js': 'js-eu1'
    crel(document.head, crel('script', {id: 'hs-script-loader', src: `//${srv}.hs-scripts.com/${script}.js`}))


    if(!korak) return

    console.log(`Executed: Hubspot special call - ${korak}`)

    const send_data = async () => {
        const {result, error} = await resolver(axios.get(`${location.origin}/services/apiv2/user_data/`))
        if (error) return alert(error)

        const email = !result.data.authenticated ? 'Anonymous' : result.data.user_email

        _hsq.push(["identify", {email}]);
        _hsq.push([
            'trackCustomBehavioralEvent',
            {
                name: `pe${script}_via_v2`,
                properties: {
                    url: location.href,
                    step: korak
                },
            },
        ]);
    }

    // Because the _hsq does not appear at any known time, we need to do this
    (function myLoop() {
        setTimeout(function () {
            if (!window._hsq) return myLoop();
            if(korak) send_data()
        }, 100)
    })();
}